import { Nullable } from 'common-types';
import { createStore } from 'store-utils';
import { FileFix } from '../types/quick-fix-types';

const QuickFixStore = createStore<QuickFixStoreState>(
  {
    isLoadingCreatePR: false,
    isLoadingDeletePR: false,
    prComment: '',
    errorMessage: null,
    autoFixId: '',
    viewFileFixes: [],
    isLoadingFileFixes: false,
    commitMessage: '',
    prTitle: '',
    prBody: '',
    loadingError: false,
  },
  'Quick Fix Store',
);

interface QuickFixStoreState {
  isLoadingCreatePR: boolean;
  isLoadingDeletePR: boolean;
  errorMessage: Nullable<string>;
  prComment: string;
  autoFixId: string;
  viewFileFixes: FileFix[];
  isLoadingFileFixes: boolean;
  commitMessage: string;
  prTitle: string;
  prBody: string;
  loadingError: boolean;
}

export default QuickFixStore;
